import type { StepUpLabel } from '../store'
import { useCallback } from 'react'
import { StepUpRequiredError } from '../api/client'
import { useShell } from '../store'

/**
 * Runs a Tier 1/2 call; when the API answers step_up_required, the shell modal asks for a code and
 * the call is retried once (PRD-019 §3.6). A canceled modal rejects with `cancelled`. `label` is the one line the
 * modal shows, or the PRD-016 §7.18 box (action · object · amount · company) for a books write (UX audit 2026-09-19 P1-4).
 */
export function useWithStepUp() {
  const { requestStepUp } = useShell()
  return useCallback(async <T>(label: StepUpLabel, call: () => Promise<T>): Promise<T> => {
    try {
      return await call()
    }
    catch (e) {
      if (e instanceof StepUpRequiredError) {
        const ok = await requestStepUp(e.tier, e.action, label)
        if (!ok)
          throw new Error('cancelled')
        return call()
      }
      throw e
    }
  }, [requestStepUp])
}
